// src/containers/CompetitionOverviewContainer.js
import React, { useContext, useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { CompetitionContext } from '../contexts/CompetitionContext';
import CompetitionOverview from '../components/CompetitionOverview/CompetitionOverview';
import { Card } from 'react-bootstrap';
import Loading from '../components/Common/Loading';

const CompetitionOverviewContainer = () => {
    const { competition, isLoading, error, isUserJoined, setIsUserJoined, setCompetition } = useContext(CompetitionContext);
    const navigate = useNavigate();

    const sortedCompetitors = useMemo(() => {
        if (!competition) return [];
        return [...competition.competitors].sort((a, b) => b.totalPoints - a.totalPoints);
    }, [competition]);

    const lowestCompetitor = useMemo(() => {
        if (!competition || !competition.competitors.length) return null;
        return competition.competitors.reduce((lowest, competitor) =>
            lowest.totalPoints < competitor.totalPoints ? lowest : competitor,
            competition.competitors[0]
        );
    }, [competition]);

    const currentPeriod = useMemo(() => {
        if (!competition) return { startDate: null, endDate: null };
        return { startDate: competition.startDate, endDate: competition.endDate };
    }, [competition]);

    const competitorsWithProgress = useMemo(() => {
        if (!competition || !competition.competitors.length) return [];
        return sortedCompetitors.map(competitor => {
            const meetsCriteria = competitor.totalPoints >= parseFloat(competition.minimumPoints);
            const progress = (competitor.totalPoints / parseFloat(competition.minimumPoints)) * 100;
            return { ...competitor, meetsCriteria, progress };
        });
    }, [sortedCompetitors, competition]);

    const handleUsernameClick = useCallback((username) => {
        navigate(`/profile/${username}`);
    }, [navigate]);

    if (isLoading || !competition) {
        return (
            <Card.Body>
                <Loading />
            </Card.Body>
        )
    }

    if (error) {
        return <div className="alert alert-danger">Error: {error}</div>;
    }

    return (
        <CompetitionOverview
            competitors={competitorsWithProgress}
            ministerOfActivity={competition?.ministerOfActivity}
            lowestCompetitor={lowestCompetitor}
            currentPeriod={currentPeriod}
            onUsernameClick={handleUsernameClick}
            isUserJoined={isUserJoined}
            competitionId={competition.competitionId.toString()}
            setIsUserJoined={setIsUserJoined}
            setCompetition={setCompetition}
        />
    );
};

export default CompetitionOverviewContainer;
